import React, { createContext } from "react";

export interface PortalProviderProps {
  root: HTMLElement | null;
  children?: React.ReactNode;
}

export const PortalContext = createContext<PortalProviderProps["root"]>(null);

export const PortalProvider = ({ root, children }: PortalProviderProps) => {
  return (
    <PortalContext.Provider value={root}>{children}</PortalContext.Provider>
  );
};
